/** @jsxImportSource @emotion/react */
import React from 'react'
import { Rectangle } from 'recharts'

// Recharts BarChart calculates 'activeIndex' of the currently activated tooltip internally
// If we want a tooltip in a fixed position we can render a custom tooltip cursor
// If 'activeTooltip' is set it will use that location, otherwise it will move with mouse hover

const FixedTooltipCursor = props => {
  const { stroke, fill, width, height, className, x, y, activeTooltip } = props
  const pos = activeTooltip?.active ? activeTooltip.x - 0.5 * width : x

  return (
    <Rectangle
      x={pos}
      y={y}
      stroke={stroke}
      fill={fill}
      width={width}
      height={height}
      className={className}
      type="linear"
      pointerEvents="visiblePainted"
      style={{cursor: 'pointer'}}
    />
  )
}

export default FixedTooltipCursor